export const KM_TO_MILES = 0.621371;

export const INTEGRATION_NOT_RUN = "N/A (not modeled)";
export const INTEGRATION_FOREIGN = "N/A (foreign)";
export const INTEGRATION_ZERO_TIV = "N/A ($0 TIV)";
export const INTEGRATION_NO_MATCH = "N/A (no match)";

const parseNumericField = (val: string | null | undefined): number | null => {
  if (val == null) return null;
  const n = parseFloat(String(val).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(n) ? n : null;
};

// Blended ITV ($/sqft): total building value divided by total square footage
// across locations that report both a numeric building value and a non-zero
// square footage. Locations missing either are excluded from both sums, so the
// figure reflects only the locations it can actually be computed from. Returns
// null when no qualifying location exists.
export const blendedItvPerSqft = (
  addresses: {
    building_value?: string | null;
    square_footage?: string | null;
  }[]
): number | null => {
  let totalBuildingValue = 0;
  let totalSquareFootage = 0;
  for (const a of addresses) {
    const buildingValue = parseNumericField(a.building_value);
    const squareFootage = parseNumericField(a.square_footage);
    if (buildingValue == null || squareFootage == null || squareFootage <= 0) {
      continue;
    }
    totalBuildingValue += buildingValue;
    totalSquareFootage += squareFootage;
  }
  return totalSquareFootage === 0
    ? null
    : totalBuildingValue / totalSquareFootage;
};
